export const LOCATION_TYPES = [
  { label: 'Residence', value: 'residence' },
  { label: 'School', value: 'school' },
  { label: 'Other', value: 'other' },
];

export const RESIDENCE = 'residence';
export const SCHOOL = 'school';
export const OTHER = 'other';
